import { Outlet } from "react-router-dom"
import Header from "./Header"
import Footer from "./Footer"
import NavHeader from "./NavHeader"
import Sidebar from "./Sidebar"
import Preload from "../common/Preload"
import $ from 'jquery';
import { useEffect } from "react"

const PageLayout = () => {
  useEffect(() => {
    const initNavControl = () => {
      $(".nav-control").on("click", function () {
        $("#main-wrapper").toggleClass("menu-toggle");
        $(".hamburger").toggleClass("is-active");
      });
    };

    initNavControl();

    return () => {
      $(".nav-control").off("click");
    };
  }, []);

  return (<>
    <Preload />
    <div id="main-wrapper">
      <NavHeader />
      <Header />
      <Sidebar />
      <div className="content-body default-height">
        <Outlet />
      </div>
      <div className="modal fade" id="modalBackdrop" />
      <Footer />
    </div>
  </>)
}

export default PageLayout
